import { Accordion } from "@app/shared/Accordion"
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import ProviderNetworkTypeBadge from "@app/shared/ProviderNetworkTypeBadge";
import { sortProviderNetworkTypes } from "@app/shared/enums/providerNetworkTypeEnum";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import formatPhoneNumber from "@app/shared/formatPhoneNumber";
import { NO_ACTIONS_APPLIED_LABEL } from "@app/projects/network-assessment/provider-hub/utility";
import { CountyProjectContext } from "@app/projects/CountyProjectContext";

export const ContractEntityProfileOverview: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const projectContext = useContext(CountyProjectContext);
  const { selectedContractEntity } = providerHubContext;

  return (
    <Accordion title="Overview" testId="provider-profile__overview-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Entity Type</dt>
          <dd className={`provider-profile__overview-value--entitytype`}>
            {selectedContractEntity.entityType}
          </dd>
        </div>

        <div className="provider-profile__overview-row--source">
          <dt className="provider-profile__overview-label--source">Provider Source</dt>
          <dd className="provider-profile__overview-value">
            {sortProviderNetworkTypes(selectedContractEntity.providerNetworkTypes).map((pt) => (
              <ProviderNetworkTypeBadge badgeStyle={ProviderBadgeStyle.Outline} providerNetworkType={pt} key={pt} />
            ))}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label--status">Status</dt>
          <dd className="provider-profile__overview-value--status">
            {selectedContractEntity.providerActionStatuses.length > 0 ? (
              selectedContractEntity.providerActionStatuses.map((item) => (
                <ol key={item}>
                  <li><ProviderActionStatusBadge badgeStyle={ProviderBadgeStyle.Dot} status={item} /></li>
                </ol>
              ))
            ) : (
              NO_ACTIONS_APPLIED_LABEL
            )}
          </dd>
        </div>
        {projectContext.project.showPciData && <>
          <div className="provider-profile__overview-row">
            <dt className="provider-profile__overview-label">Average Effectiveness (Quality) Score</dt>
            <dd className="provider-profile__overview-value">
              {selectedContractEntity.filteredQuality ?? "---"}/5.0
            </dd>
          </div>

          <div className="provider-profile__overview-row">
            <dt className="provider-profile__overview-label">Average Efficiency (Cost) Score</dt>
            <dd className="provider-profile__overview-value">
              {selectedContractEntity.filteredCost ?? "---"}/5.0
            </dd>
          </div>
        </>
        }
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Phone Number</dt>
          <dd className="provider-profile__overview-value">
            {formatPhoneNumber(selectedContractEntity.phoneNumber)}
          </dd>
        </div>
      </dl>
    </Accordion>
  )
};